export class ProductsClassesGroup {
    constructor({
                    //attributes
                    id = null,
                    company_id = null,
                    name = '',
                    default_total_formula_id = null,
                    formula_conditions = [],
                    //relations
                    classes = []
                } = {}) {

        //fill attributes
        this.id = id;
        this.company_id = company_id;
        this.name = name;
        this.default_total_formula_id = default_total_formula_id;
        this.formula_conditions = formula_conditions;

        //fill relations
        this.classes = classes
    }

}

export function createProductsClassesGroup(data={}) {
    return Object.freeze(new ProductsClassesGroup(data));
}